// Top 10 most spoken languages worldwide
// Source: Ethnologue 2024 (total speakers)
export const TOP_LANGUAGES = [
  { code: "en", label: "Inglês", native: "English", flag: "🇺🇸" },
  { code: "zh", label: "Mandarim", native: "中文", flag: "🇨🇳" },
  { code: "hi", label: "Hindi", native: "हिन्दी", flag: "🇮🇳" },
  { code: "es", label: "Espanhol", native: "Español", flag: "🇪🇸" },
  { code: "ar", label: "Árabe", native: "العربية", flag: "🇸🇦" },
  { code: "fr", label: "Francês", native: "Français", flag: "🇫🇷" },
  { code: "bn", label: "Bengali", native: "বাংলা", flag: "🇧🇩" },
  { code: "pt", label: "Português", native: "Português", flag: "🇧🇷" },
  { code: "ru", label: "Russo", native: "Русский", flag: "🇷🇺" },
  { code: "ur", label: "Urdu", native: "اردو", flag: "🇵🇰" },
];

export function languageLabel(code) {
  const l = TOP_LANGUAGES.find((x) => x.code === code);
  if (!l) return code || "—";
  return `${l.flag} ${l.label}`;
}
